/**
 * Module: Resilience
 * Global Error Boundary & Graceful Degradation
 */

const logError = (type, error, context = {}) => {
    // 1. Local Logging (Staff Level verbosity)
    console.error(`🚨 [Resilience::${type}]`, error, context);

    // 2. Telemetry (Send to Analytics if available)
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'exception', {
            description: `${type}: ${error.message || error}`,
            fatal: false,
            ...context
        });
    }
};

export const initResilience = () => {
    if (window.ResilienceInitialized) return;

    window.addEventListener('error', (event) => {
        logError('UnhandledError', event.error || event.message, {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        logError('UnhandledRejection', event.reason);
    });

    window.ResilienceInitialized = true;
    console.debug('🛡️ [Resilience] Global Error Boundaries active.');
};

/**
 * Wrapper to execute code safely without breaking the main thread
 */
export const withErrorBoundary = async (componentName, executeFn) => {
    try {
        await executeFn();
    } catch (error) {
        logError('ComponentCrash', error, { component: componentName });
    }
};

// Core Web Vitals Observer (Enterprise Monitoring)
if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
    try {
        const observer = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                console.debug(`📊 [Metrics] ${entry.name}:`, entry.startTime);
            });
        });
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
        observer.observe({ type: 'layout-shift', buffered: true });
    } catch (e) {
        console.warn('PerformanceObserver not supported for requested types.');
    }
}
